import React from 'react';
import Lottie from 'react-lottie';
import './Rating_Submitted_Lottie.css';
import * as animationData from './Rating_Submitted_Lottie.json';

function Rating_Submitted_Lottie(){
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    
    return (
      <section className='main'>
            <div className='Rating_Submitted_Lottie_icon'>
                <Lottie className="me-auto"
                options={defaultOptions}
                // height={60}
                // width={60}          
                />       
        </div>
      </section>
    );
}
export default Rating_Submitted_Lottie;